import { Reducer } from 'redux';
import {
  Types,
  IDataOrderSimulate,
  IOrderSimulateState,
  ICheckoutResponse,
  ISalesParams,
  ICustomerIdParams
} from './types';

export const CHECKOUT_ORDERS_INITIAL_STATE: IOrderSimulateState = {
  loading: false,
  error: false,
  params: null,
  data: null,
  ordersSent: [],
  ordersTable: [],
  loadingOrdersSent: false,
  errorOrdersSent: false,
  orderConfirmationRequested: false,
  errorMessage: undefined,
  pdf: {
    text: null,
    table: null
  }
};

type TCustomAction = {
  type: Types;
  payload: {
    params: IDataOrderSimulate;
    data: ICheckoutResponse;
    paramsOrders: ISalesParams;
    responseOrders: string[];
    customerIdParams: ICustomerIdParams;
    customerId: string;
    errorMessage: string;
  };
};

const reducer: Reducer<IOrderSimulateState, TCustomAction> = (
  state = CHECKOUT_ORDERS_INITIAL_STATE,
  action
) => {
  switch (action.type) {
    case Types.REQUEST_ORDER_SIMULATE:
      return {
        loading: true,
        error: false,
        params: action.payload.params,
        data: null,
        ordersSent: [],
        loadingOrdersSent: false,
        errorOrdersSent: false,
        orderConfirmationRequested: false,
        pdf: {
          text: null,
          table: null
        },
        ordersTable: []
      };

    case Types.REQUEST_ORDER_SIMULATE_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        loading: false,
        error: false
      };

    case Types.REQUEST_ORDER_SIMULATE_FAILURE:
      return {
        params: action.payload.params,
        data: null,
        loading: false,
        error: true,
        ordersSent: [],
        loadingOrdersSent: false,
        errorOrdersSent: false,
        orderConfirmationRequested: false,
        pdf: {
          text: null,
          table: null
        },
        ordersTable: []
      };

    case Types.REQUEST_FINALIZE_SALE:
      return {
        ...state,
        errorOrdersSent: false,
        loadingOrdersSent: true
      };

    case Types.FINALIZE_SALE_SUCCESS:
      return {
        ...state,
        saleSent: action.payload.paramsOrders,
        errorOrdersSent: false,
        loadingOrdersSent: false,
        orderConfirmationRequested: true,
        errorMessage: undefined
      };

    case Types.FINALIZE_SALE_FAILURE:
      return {
        ...state,
        saleSent: [],
        errorOrdersSent: true,
        loadingOrdersSent: false,
        orderConfirmationRequested: false,
        errorMessage: action.payload.errorMessage
      };

    case Types.RESET_SALE_FAILURE_CONFIRMATION:
      return {
        ...state,
        errorOrdersSent: false
      };

    case Types.CLEAN_ORDER_SIMULATE:
      return CHECKOUT_ORDERS_INITIAL_STATE;

    case Types.UPDATE_CUSTOMER_PURCHASE_ID:
      if (state.data?.orders.length) {
        const tempOrders = [...state.data.orders];
        tempOrders.forEach((orders) => {
          orders.order.forEach((order) => {
            order.extension_attributes.sap_fields.o_header_sap.purch_no_c =
              action.payload.customerId;
          });
        });

        return {
          ...state,
          data: {
            ...state.data,
            orders: tempOrders
          }
        };
      }
      return { ...state };

    case Types.UPDATE_CUSTOMER_ORDER_ID:
      if (state.data?.orders.length) {
        const tempOrders = [...state.data.orders];
        const tempOrderTable =
          tempOrders[Number(action.payload.customerIdParams.salesOrderId)];
        const itemTemp = tempOrderTable.order.find(
          (order, index) =>
            order.sku === action.payload.customerIdParams.itemId &&
            index === action.payload.customerIdParams.index
        );
        if (itemTemp)
          itemTemp.extension_attributes.item_id_gerdau =
            action.payload.customerIdParams.customerId;

        return {
          ...state,
          data: {
            ...state.data,
            orders: tempOrders
          }
        };
      }
      return { ...state };

    case Types.UPDATE_CHECKOUT_STATE_LOCAL_STORAGE:
      return { ...state };

    case Types.UPDATE_CHECKOUT_STATE:
      return {
        ...state,
        data: action.payload.data,
        params: action.payload.params
      };

    default:
      return state;
  }
};

export default reducer;
